
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * CommissionChargingType enum
 */
class CommissionChargingType {
  /**
   * Initialize enum with a given value
   * @param {CommissionChargingType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof CommissionChargingType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!CommissionChargingType}
   * @param {!CommissionChargingType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CommissionChargingType)) {
      throw new TypeError('Instance of CommissionChargingType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!CommissionChargingType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!CommissionChargingType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === CommissionChargingType.ROUND_TURN.value) {
      return 'ROUND_TURN'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!CommissionChargingType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!CommissionChargingType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!CommissionChargingType} Created enum
   */
  static fromObject (other) {
    return new CommissionChargingType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
CommissionChargingType.ROUND_TURN = new CommissionChargingType(0 + 0)

export { CommissionChargingType };

/**
 * Fast Binary Encoding CommissionChargingType field model
 */
class FieldModelCommissionChargingType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelCommissionChargingType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelCommissionChargingType}
   * @param {CommissionChargingType=} defaults Default value, defaults is new CommissionChargingType()
   * @returns {!CommissionChargingType} Result value
   */
  get (defaults = new CommissionChargingType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new CommissionChargingType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelCommissionChargingType}
   * @param {!CommissionChargingType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelCommissionChargingType };
